import { useEffect, useState } from "react";
import { Lightning } from "@phosphor-icons/react";

const HEADLINES = [
    { tag: "MOBILITY",  text: "Regional SWF extends OEM partnership; EV production JV targets 500k units by 2030", tone: "text-fp-success" },
    { tag: "ENERGY",    text: "Regional giga-project signs largest green-H₂ offtake with European buyer — sector re-rated",  tone: "text-fp-success" },
    { tag: "CAPITAL",   text: "SAMA raises capital adequacy floor to 10.5% — sector-wide impact on lending",    tone: "text-fp-saffron" },
    { tag: "RETAIL",    text: "Red Sea shipping disruptions add 12-18 days to lead times — inventory at risk",  tone: "text-fp-terracotta" },
    { tag: "REAL ESTATE", text: "Dubai commercial rents up 18% YoY — Grade A supply tightening through 2026",   tone: "text-fp-success" },
    { tag: "TÜRKIYE",   text: "TCMB continues aggressive tightening — policy rate held at 45%",                 tone: "text-fp-saffron" },
    { tag: "HEALTH",    text: "Vision 2030 raises private-sector healthcare share target to 35% by 2027",       tone: "text-fp-success" },
    { tag: "EGYPT",     text: "IMF $8B disbursement approved — third tranche linked to state-asset divestment", tone: "text-fp-saffron" },
    { tag: "GROUP",     text: "OECD Pillar-2 minimum tax implementation now live across GCC and North Africa",   tone: "text-fp-terracotta" },
];

export default function NewsTicker() {
    const [tick, setTick] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setTick((t) => t + 1), 40); // move ~25 fps
        return () => clearInterval(id);
    }, []);
    const duplicated = [...HEADLINES, ...HEADLINES]; // seamless loop
    const offset = -(tick % (HEADLINES.length * 480));
    return (
        <div className="w-full bg-fp-ink text-white overflow-hidden border-b border-fp-ink" data-testid="news-ticker">
            <div className="flex items-stretch w-full">
                <div className="shrink-0 px-3 sm:px-4 py-2 bg-fp-terracotta flex items-center gap-2">
                    <Lightning size={11} weight="fill" />
                    <span className="font-sans text-[10px] uppercase tracking-[0.2em] sm:tracking-[0.3em] font-medium hidden sm:inline">Market Pulse</span>
                    <span className="font-sans text-[10px] uppercase tracking-[0.2em] font-medium sm:hidden">Pulse</span>
                </div>
                <div className="relative flex-1 min-w-0 overflow-hidden">
                    <div className="flex items-center whitespace-nowrap py-2" style={{ transform: `translateX(${offset}px)`, willChange: "transform" }}>
                        {duplicated.map((h, i) => (
                            <span key={i} className="inline-flex items-center px-4 sm:px-6 gap-2 sm:gap-3 border-r border-white/10">
                                <span className={`font-mono text-[9px] uppercase tracking-widest px-1.5 py-0.5 border border-white/25 ${h.tone.replace("text-", "text-")}`}>{h.tag}</span>
                                <span className="font-sans text-xs text-white/90">{h.text}</span>
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
